/**
 * @desc loadUserByAdapter
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.Code, options?: any) {
  return updateResponse(
    http(URL + `/load/user`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
